import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../helpers/JsonMappedModel";
import Offer from "../offer/Offer";
import Order from "../order/Order";
import ProductVariation from "../product/ProductVariation";
import Product from "../product/Product";
import SalePage from "../salePage/SalePage";
var _attributes = /*#__PURE__*/new WeakMap();
export default class OrderLine extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [OrderLine.id_attribute_name]: null,
      [OrderLine.order_line_name_attribute_name]: null,
      [OrderLine.order_line_offer_attribute_name]: Offer,
      [OrderLine.offer_attribute_name]: Offer,
      [OrderLine.product_attribute_name]: Product,
      [OrderLine.order_line_with_trashed_offer_attribute_name]: Offer,
      [OrderLine.with_trashed_offer_attribute_name]: Offer,
      [OrderLine.offer_name_attribute_name]: null,
      [OrderLine.order_line_offer_type_attribute_name]: null,
      [OrderLine.order_line_offer_discount_attribute_name]: null,
      [OrderLine.order_attribute_name]: Order,
      [OrderLine.order_line_quantity_attribute_name]: 0,
      [OrderLine.order_line_quantity_type_attribute_name]: null,
      [OrderLine.order_line_quantity_cost_attribute_name]: 0,
      [OrderLine.quantity_confirmed_attribute_name]: 0,
      [OrderLine.price_attribute_name]: 0,
      [OrderLine.order_line_price_usd_attribute_name]: 0,
      [OrderLine.total_attribute_name]: 0,
      [OrderLine.order_line_total_usd_attribute_name]: 0,
      [OrderLine.total_confirmed_attribute_name]: 0,
      [OrderLine.order_line_total_confirmed_usd_attribute_name]: 0,
      [OrderLine.type_attribute_name]: null,
      [OrderLine.created_at_attribute_name]: null,
      [OrderLine.variation_attribute_name]: ProductVariation
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getOrderAttributeName() {
    return OrderLine.order_attribute_name;
  }
  static getVariationAttributeName() {
    return OrderLine.variation_attribute_name;
  }
  static getQuantityAttributeName() {
    return OrderLine.order_line_quantity_attribute_name;
  }
  static getQuantityConfirmedAttributeName() {
    return OrderLine.quantity_confirmed_attribute_name;
  }
  static getTypeAttributeName() {
    return OrderLine.type_attribute_name;
  }
  static getPriceAttributeName() {
    return OrderLine.price_attribute_name;
  }
  static getTotalAttributeName() {
    return OrderLine.total_attribute_name;
  }
  static getConfirmedTotalAttributeName() {
    return OrderLine.total_confirmed_attribute_name;
  }
  getId() {
    return this.getAttribute(OrderLine.id_attribute_name);
  }
  getOfferName() {
    return this.getAttribute(OrderLine.offer_name_attribute_name);
  }
  getOrder() {
    return this.getAttribute(OrderLine.order_attribute_name);
  }
  getOrderLineUsdConfirmedTotal() {
    let usdTotalConfirmed = this.getAttribute(OrderLine.order_line_total_confirmed_usd_attribute_name);
    return !isNaN(Number(usdTotalConfirmed)) ? usdTotalConfirmed : 0;
  }
  getOrderLineConfirmedTotal() {
    let totalConfirmed = this.getAttribute(OrderLine.total_confirmed_attribute_name);
    return !isNaN(Number(totalConfirmed)) ? totalConfirmed : 0;
  }
  getOffer(trashed = false) {
    if (trashed) {
      var _this$getAttribute;
      return (_this$getAttribute = this.getAttribute(OrderLine.with_trashed_offer_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : this.getAttribute(OrderLine.order_line_with_trashed_offer_attribute_name);
    }
    return this.getAttribute(OrderLine.order_line_offer_attribute_name);
  }
  getSalePage(trashed = false) {
    let order = this.getOrder();
    return order instanceof Order ? order.getSalePage(trashed) : null;
  }
  getProduct() {
    let product = this.getAttribute(OrderLine.product_attribute_name);
    if (product instanceof Product) {
      return product;
    }
    let offer = this.getOffer();
    return offer instanceof Offer ? offer.getProduct() : null;
  }
  getVariation() {
    return this.getAttribute(OrderLine.variation_attribute_name);
  }
  getProductSku() {
    let product = this.getProduct();
    return product instanceof Product ? product.getSku() : null;
  }
  getVariationSku() {
    let variation = this.getVariation();
    return variation instanceof ProductVariation ? variation.getSku() : null;
  }
  getSku() {
    var _this$getVariationSku;
    return (_this$getVariationSku = this.getVariationSku()) !== null && _this$getVariationSku !== void 0 ? _this$getVariationSku : this.getProductSku();
  }
  getTotal() {
    return this.getAttribute(OrderLine.total_attribute_name);
  }
  getUsdTotal() {
    return this.getAttribute(OrderLine.order_line_total_usd_attribute_name);
  }
  getOfferType() {
    return this.getAttribute(OrderLine.order_line_offer_type_attribute_name);
  }
  getType() {
    return this.getAttribute(OrderLine.type_attribute_name);
  }
  isUpSell() {
    return this.getType() === OrderLine.UPSELL_TYPE;
  }
  getTotalConfirmed() {
    return this.getAttribute(OrderLine.total_confirmed_attribute_name);
  }
  getUsdTotalConfirmed() {
    return this.getAttribute(OrderLine.order_line_total_confirmed_usd_attribute_name);
  }
  getQuantity() {
    return this.getAttribute(OrderLine.order_line_quantity_attribute_name);
  }
  hasQuantity() {
    return this.getQuantity() > 0;
  }
  hasQuantityConfirmed() {
    return this.getQuantityConfirmed() > 0;
  }
  getQuantityConfirmed() {
    return this.getAttribute(OrderLine.quantity_confirmed_attribute_name);
  }
  getOrderLineType() {
    return this.getAttribute(OrderLine.type_attribute_name);
  }
  isMain() {
    return this.getOrderLineType() === OrderLine.MAIN_TYPE;
  }
  isUpsell() {
    return this.getOrderLineType() === OrderLine.UPSELL_TYPE;
  }
  isCrossSell() {
    return this.getOrderLineType() === OrderLine.CROSS_SELL_TYPE;
  }
  getCallUpsellQuantity() {
    return this.isUpsell() ? this.getQuantityConfirmed() - this.getQuantity() : 0;
  }
  getCallUpsellTotal() {
    return this.isUpsell() ? this.getTotalConfirmed() - this.getTotal() : 0;
  }
}
_defineProperty(OrderLine, "MAIN_TYPE", 'main');
_defineProperty(OrderLine, "UPSELL_TYPE", 'upsell');
_defineProperty(OrderLine, "CROSS_SELL_TYPE", 'cross-sell');
_defineProperty(OrderLine, "id_attribute_name", 'order_line_id');
_defineProperty(OrderLine, "order_line_name_attribute_name", 'order_line_name');
_defineProperty(OrderLine, "order_line_offer_attribute_name", 'order_line_offer');
_defineProperty(OrderLine, "offer_attribute_name", 'offer');
_defineProperty(OrderLine, "product_attribute_name", 'product');
_defineProperty(OrderLine, "order_line_with_trashed_offer_attribute_name", 'order_line_with_trashed_offer');
_defineProperty(OrderLine, "with_trashed_offer_attribute_name", 'with_trashed_offer');
_defineProperty(OrderLine, "offer_name_attribute_name", 'order_line_offer_name');
_defineProperty(OrderLine, "order_line_offer_type_attribute_name", 'order_line_offer_type');
_defineProperty(OrderLine, "order_line_offer_discount_attribute_name", 'order_line_offer_discount');
_defineProperty(OrderLine, "order_attribute_name", 'order_line_order');
_defineProperty(OrderLine, "order_line_quantity_attribute_name", 'order_line_quantity');
_defineProperty(OrderLine, "order_line_quantity_type_attribute_name", 'order_line_quantity_type');
_defineProperty(OrderLine, "order_line_quantity_cost_attribute_name", 'order_line_quantity_cost');
_defineProperty(OrderLine, "quantity_confirmed_attribute_name", 'order_line_quantity_confirmed');
_defineProperty(OrderLine, "price_attribute_name", 'order_line_price');
_defineProperty(OrderLine, "order_line_price_usd_attribute_name", 'order_line_price_usd');
_defineProperty(OrderLine, "total_attribute_name", 'order_line_total');
_defineProperty(OrderLine, "order_line_total_usd_attribute_name", 'order_line_total_usd');
_defineProperty(OrderLine, "total_confirmed_attribute_name", 'order_line_total_confirmed');
_defineProperty(OrderLine, "order_line_total_confirmed_usd_attribute_name", 'order_line_total_confirmed_usd');
_defineProperty(OrderLine, "type_attribute_name", 'order_line_type');
_defineProperty(OrderLine, "created_at_attribute_name", 'created_at');
_defineProperty(OrderLine, "variation_attribute_name", 'variation');